import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { InfoIcon } from 'foundations-assets';
import LineItems from '../LineItems/LineItems';
import FutureChargesValidationMessages from './FutureChargesValidationMessages';
import { useValidationErrors } from '../../hooks/useValidationErrors';
import { getShowAllErrors } from '../../state/errorMessagesSlice';
import { useSelector } from 'react-redux';
import { getLineItemBlurs } from '../../state/lineItemBlursSlice';
import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import { Flex } from 'foundations-components/components/Flex';
import useMinMaxAmountsFromValidationErrors from '../../hooks/useMinMaxAmountsFromValidationErrors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FutureCharges = ({
  futureStartDateLineItems,
  currencyCode,
  lineItemErrors,
  readOnly,
  selectionToggles,
  selectedItems,
  sessionOpen,
  isZeroCheckout,
  lineItemTaxLabel,
  shouldDisplayLineItemTaxes,
  areTaxLabelsDifferent,
  checkoutFeeAdjustment
}) => {
  const {
    subtotalsValidationErrors
  } = useValidationErrors();
  const showAllErrors = useSelector(getShowAllErrors);
  const lineItemBlurs = useSelector(getLineItemBlurs);
  const shouldShowFutureChargesRecurringMessage = showAllErrors || futureStartDateLineItems.some(lineItem => lineItemBlurs[lineItem.id]);
  const futureStartDateValidationErrors = useMemo(() => {
    return subtotalsValidationErrors.filter(error => {
      var _error$context;
      return !!((_error$context = error.context) !== null && _error$context !== void 0 && (_error$context = _error$context.initialPaymentType) !== null && _error$context !== void 0 && _error$context.includes('FUTURE_START_DATE'));
    });
  }, [subtotalsValidationErrors]);
  const {
    minimumAmount,
    maximumAmount,
    isRecurringTotalBelowMin,
    isRecurringTotalAboveMax
  } = useMinMaxAmountsFromValidationErrors({
    validationErrors: futureStartDateValidationErrors,
    shouldShowRecurring: shouldShowFutureChargesRecurringMessage
  });
  const tooltipMessage = useMemo(() => isZeroCheckout ? 'payments.futureCharges.zeroCheckoutTooltip' : 'payments.futureCharges.headerTooltip', [isZeroCheckout]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "baseline",
      backgroundColor: "border-core-disabled",
      paddingInline: "600",
      paddingBlock: "300",
      gap: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "payments.futureCharges.header"
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: tooltipMessage,
          options: {
            count: futureStartDateLineItems.length
          }
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {
          size: "100",
          color: "icon-core-default"
        })
      })]
    }), /*#__PURE__*/_jsx(LineItems, {
      selectionToggles: selectionToggles,
      selectedItems: selectedItems,
      lineItems: futureStartDateLineItems,
      currencyCode: currencyCode,
      readOnly: readOnly,
      lineItemErrors: lineItemErrors,
      sessionOpen: sessionOpen,
      lineItemTaxLabel: lineItemTaxLabel,
      shouldDisplayLineItemTaxes: shouldDisplayLineItemTaxes,
      areTaxLabelsDifferent: areTaxLabelsDifferent,
      checkoutFeeAdjustment: checkoutFeeAdjustment
    }), /*#__PURE__*/_jsx(FutureChargesValidationMessages, {
      minimumAmount: minimumAmount,
      maximumAmount: maximumAmount,
      currencyCode: currencyCode,
      isRecurringTotalBelowMin: isRecurringTotalBelowMin,
      isRecurringTotalAboveMax: isRecurringTotalAboveMax,
      topMargin: (isRecurringTotalAboveMax || isRecurringTotalBelowMin) && futureStartDateLineItems.length === 1 ? '-400' : undefined
    }), /*#__PURE__*/_jsx(HR, {
      distance: "md",
      margin: "0"
    })]
  });
};
export default FutureCharges;